import React, { useState } from "react";
import styles from "./ViewArchived.module.css";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import Dropdown from "../../components/Dropdown/Dropdown";
import IconAndName from "../../components/IconAndName/IconAndName";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { IoAddCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import SearchBar from "../../components/SearchBar/SearchBar";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import CopyRight from "../../components/CopyRight/CopyRight";
import { useNavigate } from "react-router-dom";

const ViewArchieved = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedActions, setSelectedActions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const navigate = useNavigate();
  const data = [
    {
      _id: "1",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9894994009",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "2",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9894994949",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "3",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "97387493843",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "4",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9849950050",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
  ];

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        studentName: (
          <LogoWithName name={item.studentName} dateRange={item.subLabel} />
        ),
        status: item.status,
        contact: item.contact,
        lastFollowUp: item.lastFollowUp,
        nextFollowUp: item.nextFollowUp,
        source: item.source,
        assignedTo: item.assignedTo,
        dueDate: item.dueDate,
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            setSelectedIds(
              e.target.checked ? data.map((item) => item._id) : []
            );
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Status", accessor: "status" },
    { title: "Primary Contact", accessor: "contact" },
    { title: "Last Follow up", accessor: "lastFollowUp" },
    { title: "Next Follow up", accessor: "nextFollowUp" },
    { title: "Source", accessor: "source" },
    { title: "Assigned To", accessor: "assignedTo" },
    { title: "Due date", accessor: "dueDate" },
  ];

  const handleConfigureColumn = () => {dispatch(openModal("configureColumn"));
  };
  const handleAddClick = () => dispatch(openModal("addEnquiry"));

  return (
      <>
      <div className={styles.screen}>
        <div className={styles.contentWrapper}>
          <h4
            style={{
              color: "var(--Primary_Color)",
              fontWeight: "400",
              marginBottom: "0.5rem",
              marginTop: "0.5rem",
            }}
          >
            Archieved Enquiries
          </h4>

          <div className={styles.totaldatacard}>
            <div className={styles.barsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search activity"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.fourfilters}>
                <button
                  className={styles.archiveBtn}
                  onClick={handleConfigureColumn}
                >
                  Unassigned
                </button>
                <Dropdown
                  label="Staff"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedStaff}
                />
                <Dropdown
                  label="Actions"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedActions}
                />
                <button
                  className={styles.archiveBtn}
                  onClick={handleConfigureColumn}
                >
                  Configure Column
                </button>
              </div>
            </div>

            <div>
              <div className={styles.dynamicdata}>
                <DynamicTable
                  headings={headingsData}
                  columnData={displayData.slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )}
                />
              </div>
              <div className={styles.paginationTable}>
                <PaginationTable
                  data={displayData}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default ViewArchieved;
